let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7Rita")).then(() => parcelRequire('kw9Kb'));